module.exports = __webpack_public_path__ + "static/img/speed-down.c7856bad.png";